import React from "react";

function TextList({color, number, text}){
    return(
        <div className='list'>
            <div className={`number-section ${color}`}>
                <p>{number}</p>
            </div>
            <span><div dangerouslySetInnerHTML={{__html: text}}/></span>
        </div>
    );
}

export default function AlurPeminjamanTextIndividu({type}){
    switch (type) {
        case 'kmg':
            return(
                <div className='alur-peminjaman-text'>
                    <TextList color='green' 
                        number={1} text='Calon Penerima Dana mengajukan permohonan pinjaman secara online melalui website atau aplikasi Danai.id'/>
                        <TextList color='green' 
                        number={2} text='Danai.id memproses pengajuan pinjaman sesuai dengan prosedur yang berlaku'/>
                        <TextList color='grey' 
                        number={3} text='Jika pengajuan pinjaman disetujui, Danai.id akan mengirimkan penawaran pinjaman kepada calon Penerima Dana'/>
                        <TextList color='grey' 
                        number={4} text='Sesudah calon Penerima Dana memberikan persetujuan, pengajuan pinjaman akan masuk ke marketplace Danai.id'/>
                        <TextList color='blue' 
                        number={5} text='Pemberi Dana akan melakukan pendanaan dengan menentukan jumlah pinjaman sesuai dengan preferensi'/>
                        <TextList color='blue' 
                        number={6} text='Setelah dana terpenuhi, Danai.id akan mentransfer dana ke rekening Peminjam ke rekening yang telah terdaftar dan Peminjam dapat menggunakan dana tersebut'/>
                </div>
            );
            break;
    
        default:
            return(
                <div className='alur-peminjaman-text'>
                    <TextList color='green' 
                        number={1} text='Calon Penerima Dana mengajukan permohonan pinjaman secara online melalui website atau aplikasi Danai.id'/>
                        <TextList color='green' 
                        number={2} text='Danai.id memproses dan mengirimkan konfirmasi pinjaman kepada PIC perusahaan mitra tempat calon Penerima Dana bekerja'/>
                        <TextList color='grey' 
                        number={3} text='PIC perusahaan mitra melakukan validasi data dan memberikan persetujuan pengajuan pinjaman kepada Danai.id '/>
                        <TextList color='grey' 
                        number={4} text='Pengajuan pinjaman akan masuk ke <em>marketplace</em> Danai.id'/>
                        <TextList color='blue' 
                        number={5} text='Pemberi Dana akan melakukan pendanaan dengan menentukan jumlah pinjaman sesuai dengan preferensi'/>
                        <TextList color='blue' 
                        number={6} text='Setelah dana terpenuhi, Danai.id akan mengirimkan dana ke rekening Penerima Dana yang telah terdaftar setelah dikurangi biaya-biaya.'/>
                </div>
            );
            break;
    }
}